import { Link } from 'react-router-dom';

export function MobileMenu({ navLinks, isDark }) {
    return (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg" data-testid="mobile-menu">
            <div className="px-6 py-5 space-y-1">
                {navLinks.map((link) => (
                    <Link
                        key={link.href}
                        to={link.href}
                        className="block text-gray-700 font-medium py-3 text-sm hover:text-navy-900 border-b border-gray-50 transition-colors"
                        data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                        {link.label}
                    </Link>
                ))}
                <div className="pt-3">
                    <Link
                        to="/contact"
                        className="block bg-gold-400 text-white text-center px-6 py-3 rounded-sm text-sm font-semibold hover:bg-gold-500 transition-colors"
                        data-testid="mobile-nav-cta"
                    >
                        Book a Diagnostic Call
                    </Link>
                </div>
            </div>
        </div>
    );
}
